import { render, staticRenderFns } from "./PausarTiendaOnline.vue?vue&type=template&id=229f2a42&scoped=true&"
import script from "./PausarTiendaOnline.vue?vue&type=script&lang=js&"
export * from "./PausarTiendaOnline.vue?vue&type=script&lang=js&"
import style0 from "./PausarTiendaOnline.vue?vue&type=style&index=0&id=229f2a42&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229f2a42",
  null
  
)

export default component.exports